export enum ReportViews {
  GENERAL_INFORMATION = 0,
  BOOKS_INFORMATION = 1,
  CHALLENGES_INFORMATION = 2,
}
